import Http from "./http";

export const userListDropdownAPI = (data) => {
  return Http.post("admin/notificationUserList",data);
};
